export const SHUTTLE_SERVICE_ENDPOINTS = {
  getShuttleDetails: process.env.GATSBY_GET_SHUTTLE_DETAILS ?? '',
  getShuttleLocations: process.env.GATSBY_GET_SHUTTLE_LOCATIONS ?? '',
  getShuttleRoutes: process.env.GATSBY_GET_SHUTTLE_ROUTES ?? '',
} as const;
